<template>
  <Layout>
    <div class="custom-tabs-container">
      <div class="tabs-wrapper">
        <ul class="nav nav-tabs custom-tabs" role="tablist">
          <li class="nav-item" v-for="tab in tabs" :key="tab.id">
            <a
              class="nav-link"
              :class="{ active: activeTab === tab.id }"
              @click="setActiveTab(tab.id)"
              role="tab"
              :aria-selected="activeTab === tab.id"
            >
              {{ tab.name }}
            </a>
          </li>
        </ul>
      </div>

      <div class="tab-content custom-tab-content">
        <component
          v-if="activeTab === componentMapping[activeTab].id"
          :is="componentMapping[activeTab].component"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
export default {
  name: "TabsComponent",
  components: {
    Layout: () => import("../../layouts/main.vue"),
  },
  data() {
    return {
      activeTab: "psikologi",
      tabs: [
        { id: "psikologi", name: "PSIKOLOGI" },
        { id: "akademik", name: "AKADEMIK" },
        { id: "skd", name: "SKD" },
        { id: "latihan", name: "LATIHAN" },
        { id: "latihan-kecermatan", name: "LATIHAN SIKAP KERJA" },
        { id: "grafik-kecermatan", name: "GRAFIK SIKAP KERJA" },
        { id: "grafik-tryout", name: "GRAFIK TRYOUT" },
      ],
      componentMapping: {
        psikologi: {
          id: "psikologi",
          component: () => import("./index.vue"),
        },
        akademik: {
          id: "akademik",
          component: () => import("./index_akademik.vue"),
        },
        skd: {
          id: "skd",
          component: () => import("./index_skd.vue"),
        },
        latihan: {
          id: "latihan",
          component: () => import("./index_latihan.vue"),
        },
        "latihan-kecermatan": {
          id: "latihan-kecermatan",
          component: () => import("./index_latihan_kecermatan.vue"),
        },
        "grafik-kecermatan": {
          id: "grafik-kecermatan",
          component: () => import("./index_resilience_kecermatan.vue"),
        },
        "grafik-tryout": {
          id: "grafik-tryout",
          component: () => import("./index_resilience_tryout.vue"),
        },
      },
    };
  },
  methods: {
    setActiveTab(tabId) {
      this.activeTab = tabId;
    },
  },
};
</script>

<style scoped>
.custom-tabs-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.tabs-wrapper {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.custom-tabs {
  border-bottom: 2px solid #f0f0f0;
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 10px;
  padding: 0 10px;
  min-width: min-content;
  width: 100%;
}

.nav-item {
  margin-bottom: -2px;
  white-space: nowrap;
}

.nav-link {
  position: relative;
  color: #666;
  font-weight: 500;
  padding: 12px 20px;
  border: none;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  cursor: pointer;
  text-transform: uppercase;
}

.nav-link:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.02);
  border-color: transparent;
}

.nav-link.active {
  color: #4f46e5;
  border: none;
  font-weight: 600;
}

.nav-link.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #2196f3;
  transition: all 0.3s ease;
}

.custom-tab-content {
  padding: 25px 15px;
  min-height: 300px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-tabs-container {
    padding: 15px 10px;
  }

  .nav-link {
    padding: 10px 15px;
    font-size: 0.8rem;
  }

  .custom-tabs {
    gap: 5px;
  }
}

/* Animation for tab content */
.tab-content > div {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
